const getInquiringProviderTaxID = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business
    && business['Company Identify']
    && business['Company Identify'].EIN) {
    return business['Company Identify'].EIN;
  }
  return null;
};

export default getInquiringProviderTaxID;



// WEBPACK FOOTER //
// ./src/utils/print/getInquiringProviderTaxID.js